import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: null,
  type: null
};

const slice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    alert(state, action) {
      const { type, message } = action.payload;
      state.message = message;
      state.type = type;
    },
    clearAlert(state) {
      state.message = null;
      state.type = null;
    }
  }
});

export const reducer = slice.reducer;

export const alertSuccess = (message) => (dispatch) => {
  dispatch(slice.actions.alert({ type: 'success', message }));
};

export const alertError = (message) => (dispatch) => {
  dispatch(slice.actions.alert({ type: 'error', message }));
};

export const clearAlert = () => (dispatch) => {
  dispatch(slice.actions.clearAlert());
};
